module.exports = __webpack_public_path__ + "media/images/flags/fm-c916f9973caa056c4124bf77cb1ff9a4.svg";